<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <Header :showGoBack="true" />

    <main
      class="scrollable container"
      :style="{opacity: opacity}"
    >
      <section :style="{paddingTop: '24%'}">
        <h1 :style="{marginBottom: '30px', color: 'var(--main-dark)'}">
          Welcome to Apitex!
        </h1>
        <Input
          :leftIcon="MailSvg"
          :rightIcon="InputCheckSvg"
          :placeholder="'Enter your email'"
          :containerStyle="{marginBottom: '10px'}"
        />
        <Input
          :leftIcon="KeySvg"
          :rightIcon="EyeOffSvg"
          :rightIconClickable="true"
          :placeholder="'Enter your password'"
          :containerStyle="{marginBottom: '14px'}"
        />
        <div
          class="row-center-space-between"
          :style="{marginBottom: '30px'}"
        >
          <div
            class="row-center clickable"
            :style="{gap: '10px'}"
            @click="toggleCheckbox"
          >
            <div
              class="center"
              :style="{
                width: '18px',
                height: '18px',
                borderRadius: '4px',
                border: '1px solid #ff8a71',
                backgroundColor: 'var(--white-color)',
              }"
            >
              <component
                v-if="isChecked"
                :is="CheckSvg"
              />
            </div>
            <span class="t16">Remember me</span>
          </div>
          <span
            class="t16 clickable"
            :style="{color: 'var(--main-color)'}"
            @click="$router.push(routes.FORGOT_PASSWORD)"
            >Lost your password?</span
          >
        </div>
        <Button
          :title="'Sign in'"
          :onClick="() => $router.push(routes.TAB_NAVIGATOR)"
          :containerStyle="{marginBottom: '14px'}"
        />
        <div
          :class="'row-center'"
          :style="{marginBottom: '20px', gap: '4px'}"
        >
          <span :class="'t16'">No account?</span>
          <span
            :class="'t16 clickable'"
            :style="{color: 'var(--main-color)'}"
            @click="$router.push(routes.SIGN_UP)"
          >
            Register now</span
          >
        </div>
        <span
          class="'t16'"
          :style="{
            color: 'var(--text-color)',
            marginBottom: '14px',
            display: 'block',
          }"
          >Log in with social networks</span
        >
        <div
          :class="'row-center'"
          :style="{gap: '10px'}"
        >
          <div
            :style="{
              width: '100%',
              height: '40px',
              maxWidth: 'calc(100% / 3)',
              borderRadius: '8px',
              backgroundColor: '#FFD9C3',
            }"
            class="center"
          >
            <FaceBookSvg />
          </div>
          <div
            :style="{
              width: '100%',
              height: '40px',
              maxWidth: 'calc(100% / 3)',
              borderRadius: '8px',
              backgroundColor: '#FFD9C3',
            }"
            class="center"
          >
            <TwitterSvg />
          </div>
          <div
            :style="{
              width: '100%',
              height: '40px',
              maxWidth: 'calc(100% / 3)',
              borderRadius: '8px',
              backgroundColor: '#FFD9C3',
            }"
            class="center"
          >
            <GoogleSvg />
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup>
// vendors
import {ref} from 'vue';
import {routes} from '@/routes';

// svg
import {KeySvg} from '@/assets/svg';
import {MailSvg} from '@/assets/svg';
import {CheckSvg} from '@/assets/svg';
import {EyeOffSvg} from '@/assets/svg';
import {GoogleSvg} from '@/assets/svg';
import {TwitterSvg} from '@/assets/svg';
import {FaceBookSvg} from '@/assets/svg';
import {InputCheckSvg} from '@/assets/svg';

// components
import {Input} from '@/components';
import {Button} from '@/components';
import {Header} from '@/components';
import {Background} from '@/components';

// hooks & router
import {useOpacity} from '@/hooks';
import {useThemeColor} from '@/hooks';

// other
const isChecked = ref(false);
const toggleCheckbox = () => {
  isChecked.value = !isChecked.value;
};

useThemeColor();

const opacity = useOpacity();
</script>
